import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import "./FlightDetails.css";
import iconTrip from "../../../../assets/images/flights/trip-icon.svg";
import dateIcon from "../../../../assets/images/flights/date.svg";
import usersIcon from "../../../../assets/images/flights/users.svg";
import { PassengerSelector } from "../../../../components";
import { Calendar } from "primereact/calendar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "../../../../contexts/TranslationContext";
import { axiosGet } from "../../../../utils/apis/api";


export default function FlightDetails({
  flightSearchState,
  travelers,
  onSearchResults,
  onChange,
}) {
    const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState("OneWay");
  const [departure, setDeparture] = useState(
    flightSearchState?.departure || ""
  );
  const [destination, setDestination] = useState(
    flightSearchState?.destination || ""
  );
  const [leavingOn, setLeavingOn] = useState(flightSearchState?.leaving || "");
  const [returningOn, setReturningOn] = useState(
    flightSearchState?.returning || ""
  );

  const [adults, setAdults] = useState(travelers?.adults || 1);
  const [children, setChildren] = useState(travelers?.children || 0);
  const [infants, setInfants] = useState(travelers?.infants || 0);

  const [showPassengerSelector, setShowPassengerSelector] = useState(false);
  const [showCal, setShowCal] = useState(null);

  const depRef = useRef(null);
  const destRef = useRef(null);
  const calRef = useRef(null);

  const today = new Date();
  const maxBookDate = new Date();
  maxBookDate.setFullYear(maxBookDate.getFullYear() + 1);

  const [departureTerm, setDepartureTerm] = useState(departure);
  const [destinationTerm, setDestinationTerm] = useState(destination);

  const [departureItems, setDepartureItems] = useState([]);
  const [destinationItems, setDestinationItems] = useState([]);

  const [openDepartureList, setOpenDepartureList] = useState(false);
  const [openDestinationList, setOpenDestinationList] = useState(false);

  const [departureLoading, setDepartureLoading] = useState(false);
  const [destinationLoading, setDestinationLoading] = useState(false);

  const [departureTouched, setDepartureTouched] = useState(false);
  const [destinationTouched, setDestinationTouched] = useState(false);
  const [multiCityRows, setMultiCityRows] = useState([]);

  const [activeDepartureIdx, setActiveDepartureIdx] = useState(0);

  const handleDiscover = async () => {
    try {
      let searchCriteria = [];

      if (selectedOption === "MultiCity") {
        multiCityRows.forEach((row) => {
          if (row.departure && row.destination && row.leavingOn) {
            searchCriteria.push({
              origin: row.departure,
              destination: row.destination,
              date: row.leavingOn.includes("T")
                ? row.leavingOn
                : new Date(row.leavingOn).toISOString(),
            });
            if (row.returningOn) {
              searchCriteria.push({
                origin: row.destination,
                destination: row.departure,
                date: row.returningOn.includes("T")
                  ? row.returningOn
                  : new Date(row.returningOn).toISOString(),
              });
            }
          }
        });
      } else {
        searchCriteria.push({
          origin: departure || "CAI",
          destination: destination || "DXB",
          date: leavingOn
            ? new Date(leavingOn).toISOString()
            : new Date().toISOString(),
        });
        if (selectedOption === "RoundTrip" && returningOn) {
          searchCriteria.push({
            origin: destination || "DXB",
            destination: departure || "CAI",
            date: new Date(returningOn).toISOString(),
          });
        }
      }

      const body = {
        searchCriteria,
        passengers: [
          { passengerTypeCode: "ADT", count: adults || 1 },
          ...(children > 0
            ? [{ passengerTypeCode: "CHD", count: children }]
            : []),
          ...(infants > 0
            ? [{ passengerTypeCode: "INF", count: infants }]
            : []),
        ],
      };

      if (typeof onSearchResults === "function") {
        onSearchResults(
          fetch(
            "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.flight_api.search",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(body),
            }
          )
            .then((res) => res.json())
            .then((data) => {
if (data?.status_code && data.status_code !== 200) {
  let errorMessage = "";

  if (Array.isArray(data.result) && data.result.length > 0) {
    errorMessage = data.result
      .map((err) =>
        typeof err === "string"
          ? err
          : err.ErrorMessage || JSON.stringify(err)
      )
      .join(" | ");
  } else {
    // لو المصفوفة فاضية أو مش Array → نستخدم الـ message
    errorMessage = data.message || "An error occurred";
  }

  toast.error(errorMessage);

  throw {
    status_code: data.status_code,
    message: data.message,
    result: data.result || [],
  };
}


              return data;
            })
        );
      }
    } catch (err) {
      console.error("Flight search failed:", err);
      toast.error("Flight search failed, please try again.");
    }
  };

  // ---------------- Call API Automatically if State Present ----------------
  useEffect(() => {
    if (flightSearchState?.departure && flightSearchState?.destination) {
      handleDiscover();
    }
  }, [flightSearchState, travelers]);

  const containerRef = useRef(null);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    if (option !== "MultiCity") {
      setMultiCityRows([]);
    }
  };

  useEffect(() => {
    const rows = document.querySelectorAll(".flight-details-raw");
    rows.forEach((row) => {
      const divs = Array.from(row.querySelectorAll(".trip-info-div"));
      divs.forEach((d, i) => {
        if (i < divs.length - 1) {
          d.classList.add("has-divider");
        } else {
          d.classList.remove("has-divider");
        }
      });
    });
  }, [selectedOption, multiCityRows]);

  // const fetchAirports = async (query) => {
  //   if (query.trim().length < 2) return [];
  //   try {
  //     const url = new URL(
  //       "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport"
  //     );
  //     url.searchParams.set("search", query);
  //     const res = await fetch(url.toString(), {
  //       headers: { Accept: "application/json" },
  //     });
  //     const json = await res.json().catch(() => ({}));
  //     return (json?.result?.items || []).slice(0, 20).map((x) => ({
  //       name: x.name,
  //       type: "airport",
  //       label: x.airport_name,
  //       sublabel: x.country || "",
  //       abbreviation: x.abbreviation,
  //       raw: x,
  //     }));
  //   } catch {
  //     return [];
  //   }
  // };



const fetchAirports = async (query) => {
  if (query.trim().length < 2) return [];

  try {
    const params = { search: query };
    const json = await axiosGet(
      "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport",
      params
    );

    return (json?.result?.items || []).slice(0, 20).map((x) => ({
      name: x.name,
      type: "airport",
      label: x.airport_name,
      sublabel: x.country || "",
      abbreviation: x.abbreviation,
      raw: x,
    }));
  } catch (error) {
    console.error("Error fetching airports:", error);
    return [];
  }
};


  useEffect(() => {
    let abort = false;
    (async () => {
      if (!departureTouched) return;
      setDepartureLoading(true);
      const airports = await fetchAirports(departureTerm);
      if (!abort) {
        setDepartureItems(airports);
        setOpenDepartureList(airports.length > 0);
        setDepartureLoading(false);
      }
    })();
    return () => {
      abort = true;
    };
  }, [departureTerm, departureTouched]);

  useEffect(() => {
    let abort = false;
    (async () => {
      if (!destinationTouched) return;
      setDestinationLoading(true);
      const airports = await fetchAirports(destinationTerm);
      if (!abort) {
        setDestinationItems(airports);
        setOpenDestinationList(airports.length > 0);
        setDestinationLoading(false);
      }
    })();
    return () => {
      abort = true;
    };
  }, [destinationTerm, destinationTouched]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (calRef.current && !calRef.current.contains(event.target)) {
        setShowCal(null);
      }

      if (depRef.current && !depRef.current.contains(event.target)) {
        setOpenDepartureList(false);
      }
      if (destRef.current && !destRef.current.contains(event.target)) {
        setOpenDestinationList(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".hotellist-calendar-popover")) {
        const newRows = multiCityRows.map((row) => ({
          ...row,
          showCal: false,
        }));
        setMultiCityRows(newRows);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [multiCityRows]);

  const pickDeparture = (item) => {
    setDepartureTerm(item.abbreviation);
    setDeparture(item.abbreviation);
    setOpenDepartureList(false);
  };

  const pickDestination = (item) => {
    setDestinationTerm(item.abbreviation);
    setDestination(item.abbreviation);
    setOpenDestinationList(false);
  };

  // --- MultiCity handlers ---
  const addMultiCityRow = () => {
    setMultiCityRows([
      ...multiCityRows,
      {
        departureTerm: "",
        departure: "",
        destinationTerm: "",
        destination: "",
        leavingOn: "",
        returningOn: "",
        showCal: false,
        showReturnCal: false,
        departureTouched: false,
        destinationTouched: false,
        departureItems: [],
        destinationItems: [],
        departureLoading: false,
        destinationLoading: false,
        openDepartureList: false,
        openDestinationList: false,
      },
    ]);
  };

  const removeMultiCityRow = (index) => {
    const newRows = [...multiCityRows];
    newRows.splice(index, 1);
    setMultiCityRows(newRows);
  };

  const handleDepartureChange = async (index, value) => {
    const newRows = [...multiCityRows];
    newRows[index].departureTerm = value;
    newRows[index].departureTouched = true;
    setMultiCityRows(newRows);

    if (value.trim().length >= 2) {
      newRows[index].departureLoading = true;
      setMultiCityRows([...newRows]);
      const airports = await fetchAirports(value);
      newRows[index].departureItems = airports;
      newRows[index].openDepartureList = airports.length > 0;
      newRows[index].departureLoading = false;
      setMultiCityRows([...newRows]);
    }
  };

  const handleDestinationChange = async (index, value) => {
    const newRows = [...multiCityRows];
    newRows[index].destinationTerm = value;
    newRows[index].destinationTouched = true;
    setMultiCityRows(newRows);

    if (value.trim().length >= 2) {
      newRows[index].destinationLoading = true;
      setMultiCityRows([...newRows]);
      const airports = await fetchAirports(value);
      newRows[index].destinationItems = airports;
      newRows[index].openDestinationList = airports.length > 0;
      newRows[index].destinationLoading = false;
      setMultiCityRows([...newRows]);
    }
  };

  const pickDepartureRow = (index, item) => {
    const newRows = [...multiCityRows];
    newRows[index].departure = item.abbreviation;
    newRows[index].departureTerm = item.abbreviation;
    newRows[index].openDepartureList = false;
    setMultiCityRows(newRows);
  };

  const pickDestinationRow = (index, item) => {
    const newRows = [...multiCityRows];
    newRows[index].destination = item.abbreviation;
    newRows[index].destinationTerm = item.abbreviation;
    newRows[index].openDestinationList = false;
    setMultiCityRows(newRows);
  };

  // --- Discover handler ---
  // const handleDiscover = async () => {
  //   try {
  //     let searchCriteria = [];

  //     if (selectedOption === "MultiCity") {
  //       if (departure && destination && leavingOn) {
  //         searchCriteria.push({
  //           origin: departure,
  //           destination: destination,
  //           date: leavingOn.includes("T")
  //             ? leavingOn
  //             : new Date(leavingOn).toISOString(),
  //         });

  //         if (returningOn) {
  //           searchCriteria.push({
  //             origin: destination,
  //             destination: departure,
  //             date: returningOn.includes("T")
  //               ? returningOn
  //               : new Date(returningOn).toISOString(),
  //           });
  //         }
  //       }

  //       multiCityRows.forEach((row) => {
  //         if (row.departure && row.destination && row.leavingOn) {
  //           searchCriteria.push({
  //             origin: row.departure,
  //             destination: row.destination,
  //             date: row.leavingOn.includes("T")
  //               ? row.leavingOn
  //               : new Date(row.leavingOn).toISOString(),
  //           });

  //           if (row.returningOn) {
  //             searchCriteria.push({
  //               origin: row.destination,
  //               destination: row.departure,
  //               date: row.returningOn.includes("T")
  //                 ? row.returningOn
  //                 : new Date(row.returningOn).toISOString(),
  //             });
  //           }
  //         }
  //       });
  //     } else {
  //       // OneWay + RoundTrip
  //       searchCriteria.push({
  //         origin: departure || "CAI",
  //         destination: destination || "DXB",
  //         date: leavingOn
  //           ? new Date(leavingOn).toISOString()
  //           : new Date().toISOString(),
  //       });

  //       if (selectedOption === "RoundTrip" && returningOn) {
  //         searchCriteria.push({
  //           origin: destination || "DXB",
  //           destination: departure || "CAI",
  //           date: new Date(returningOn).toISOString(),
  //         });
  //       }
  //     }

  //     const body = {
  //       searchCriteria,
  //       passengers: [
  //         { passengerTypeCode: "ADT", count: adults || 1 },
  //         ...(children > 0 ? [{ passengerTypeCode: "CHD", count: children }] : []),
  //         ...(infants > 0 ? [{ passengerTypeCode: "INF", count: infants }] : []),
  //       ],
  //     };

  //     console.log("Final request body:", body);

  //     // ⬇️ رجع Promise للـ parent
  //     if (typeof onSearchResults === "function") {
  //       onSearchResults(
  //         fetch("https://viaggioerp.inter-netsys.com/api/method/alltimes.www.flight_api.search", {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify(body),
  //         })
  //           .then((res) => res.json())
  //           .then((data) => {
  //             console.log("API response:", data);

  //             if (data?.status_code && data.status_code !== 200) {
  //               if (data.result && data.result.length > 0) {
  //                 data.result.forEach((err) => toast.error(err.ErrorMessage));
  //               } else {
  //                 toast.error(data.message || data.main_message || "An error occurred");
  //               }
  //               throw new Error("API returned error");
  //             }

  //             if (data?.status_code === 200) {
  //               toast.success("Flight search successful!");
  //             }

  //             localStorage.setItem(
  //               "lastFlightSearch",
  //               JSON.stringify({
  //                 flightSearchState: { departure, destination, leavingOn, returningOn },
  //                 travelers: { Adults: adults, Children: children, Infants: infants },
  //                 flightsData: data,
  //               })
  //             );

  //             return data; // ⬅️ يرجع الداتا للـ parent
  //           })
  //       );
  //     }
  //   } catch (err) {
  //     console.error("Flight search failed:", err);
  //     toast.error("Flight search failed, please try again.");
  //   }
  // };

  return (
    <div className="rounded-4 p-3 position-relative">
      {/* Option selectors */}
      <div className="flight-list-checkbox">
        {["RoundTrip", "OneWay", "MultiCity"].map((opt) => (
          <div key={opt}>
            <input
              type="radio"
              id={opt.toLowerCase()}
              name="flightOption"
              className="flight-checkbox-input"
              checked={selectedOption === opt}
              onChange={() => handleOptionChange(opt)}
            />
            <label
              htmlFor={opt.toLowerCase()}
              className="flight-checkbox-label"
            >
              {opt
                .replace("RoundTrip", t("RoundTrip"))
                .replace("OneWay", t("OneWay"))
                .replace("MultiCity", t("MultiCity"))
                
                }
            </label>
          </div>
        ))}
      </div>

      <Row className="flight-details-raw">
        <Col sm={12} md={4} lg={4}>
          <div className="trip-info-box">
            <div className="city-from">
              <span className="city-name">{t("Departure")}</span>
              <div ref={depRef} className="position-relative">
                <input
                  type="text"
                  value={departureTerm}
                  placeholder={t("Departure")}
                  // className="airport-code-input"
                  className={`airport-code-input ${departureTerm ? "no-border" : ""}`}
                  onChange={(e) => {
                    setDepartureTerm(e.target.value);
                    setDepartureTouched(true);
                  }}
                  onFocus={() => setDepartureTouched(true)}
                  autoComplete="off"
                />
                {departureLoading && <Spinner animation="border" size="sm" />}
                {openDepartureList && departureItems.length > 0 && (
                  <div className="hotellist-autocomplete shadow-lg rounded-3">
                    {departureItems.map((it, idx) => (
                      <button
                        key={`${it.type}-${it.label}-${idx}`}
                        type="button"
                        className={`hotellist-autocomplete-item ${
                          idx === activeDepartureIdx ? "active" : ""
                        }`}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          pickDeparture(it);
                        }}
                      >
                        <span className="texts">
                          <span className="title">
                            {it.label} ({it.abbreviation})
                          </span>
                          <span className="subtitle">{it.sublabel}</span>
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div>
              <img src={iconTrip} alt="" className="icon-trip"></img>
            </div>
            <div className="city-to">
              <span className="city-name">{t("Destination")}</span>
              <div ref={destRef} className="position-relative">
                <input
                  type="text"
                  value={destinationTerm}
                  placeholder={t("Destination")}
                  className="airport-code-input"
                  onChange={(e) => {
                    setDestinationTerm(e.target.value);
                    setDestinationTouched(true);
                  }}
                  onFocus={() => setDestinationTouched(true)}
                  autoComplete="off"
                />
                {destinationLoading && <Spinner animation="border" size="sm" />}
                {openDestinationList && destinationItems.length > 0 && (
                  <div className="hotellist-autocomplete shadow-lg rounded-3">
                    {destinationItems.map((it, idx) => (
                      <button
                        key={`${it.type}-${it.label}-${idx}`}
                        type="button"
                        className={`hotellist-autocomplete-item ${
                          idx === activeDepartureIdx ? "active" : ""
                        }`}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          pickDestination(it);
                        }}
                      >
                        <span className="texts">
                          <span className="title">
                            {it.label} ({it.abbreviation})
                          </span>
                          <span className="subtitle">{it.sublabel}</span>
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>

        {/* Leaving on Date */}
        <Col sm={4} md={2} lg={2} className="position-relative">
          <div
            className="trip-info-div search-box"
            role="button"
            tabIndex={0}
            onClick={() => {
              setShowCal("leaving");
              setShowPassengerSelector(false);
            }}
          >
            <div>
              <img src={dateIcon} alt="" className="date-icon" />
            </div>
            <div className="trip-info-text">
              <span className="info-text">{t("LeavingOn")}</span>
              <span className="info-date">
                {leavingOn
                  ? new Date(leavingOn).toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : t("SelectDate")}
              </span>
            </div>
          </div>

          {showCal === "leaving" && (
            <div
              ref={calRef}
              className="hotellist-calendar-popover shadow-lg rounded-3 p-2"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                zIndex: 1000,
              }}
            >
              <Calendar
                value={leavingOn ? new Date(leavingOn) : null}
                onChange={(e) => {
                  const date = e && "value" in e ? e.value : null;
                  if (date) {
                    // setLeavingOn(date.toISOString().split("T")[0]);
                    setLeavingOn(date.toLocaleDateString("en-CA"));
                    setShowCal(null);
                  }
                }}
                selectionMode="single"
                numberOfMonths={1}
                readOnlyInput
                inline
                minDate={today}
                maxDate={maxBookDate}
                dateFormat="mm/dd/yy"
              />
            </div>
          )}
        </Col>

        {/* Returning on يظهر فقط في RoundTrip */}
        {selectedOption === "RoundTrip" && (
          <Col sm={4} md={2} lg={2} className="position-relative">
            <div
              className="trip-info-div search-box"
              role="button"
              tabIndex={0}
              onClick={() => {
                setShowCal("returning");
                setShowPassengerSelector(false);
              }}
            >
              <div>
                <img src={dateIcon} alt="" className="date-icon" />
              </div>
              <div className="trip-info-text">
                <span className="info-text">{t("ReturningOn")}</span>
                <span className="info-date">
                  {returningOn
                    ? new Date(returningOn).toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : t("SelectDate")}
                </span>
              </div>
            </div>

            {showCal === "returning" && (
              <div
                ref={calRef}
                className="hotellist-calendar-popover shadow-lg rounded-3 p-2"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  zIndex: 1000,
                }}
              >
                <Calendar
                  value={returningOn ? new Date(returningOn) : null}
                  onChange={(e) => {
                    const date = e && "value" in e ? e.value : null;
                    if (date) {
                      // setReturningOn(date.toISOString().split("T")[0]);
                      setReturningOn(date.toLocaleDateString("en-CA"));
                      setShowCal(null);
                    }
                  }}
                  selectionMode="single"
                  numberOfMonths={1}
                  readOnlyInput
                  inline
                  minDate={today}
                  maxDate={maxBookDate}
                  dateFormat="mm/dd/yy"
                />
              </div>
            )}
          </Col>
        )}
        <Col sm={4} md={2} lg={2}>
          <div
            className="trip-info-div passenger-col "
            onClick={() => setShowPassengerSelector(true)}
            style={{ cursor: "pointer" }}
          >
            <div>
              <img src={usersIcon} alt="" className="date-icon"></img>
            </div>
            <div className="trip-info-text position-relative">
              <span className="info-text">{t("Passengers")}</span>
              <span className="info-date">
                {adults} {t("Adults")}, {children} {t("Children")}
              </span>
            </div>

            {/* Passenger Selector */}
            {showPassengerSelector && (
              <PassengerSelector
                adults={adults}
                children={children}
                infants={infants}
                onAdultsChange={setAdults}
                onChildrenChange={setChildren}
                onInfantsChange={setInfants}
                onClose={() => setShowPassengerSelector(false)}
                style={{
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  zIndex: 1000,
                }}
              />
            )}
          </div>
        </Col>
        <Col sm={12} md={2} lg={2} className="trip-button-col">
          <Button className="flightlist-search-button" onClick={handleDiscover}>
            {t("Discover")}
          </Button>
        </Col>
      </Row>

      {/* --- MultiCity Rows with Autocomplete --- */}
      {multiCityRows.map((row, index) => (
        <Row key={index} className="flight-details-raw mt-3">
          <Col sm={12} md={4} lg={3} className="position-relative">
            <div className="trip-info-box">
              {/* Departure */}
              <div className="city-from">
                <span className="city-name">{t("Departure")}</span>
                <div className="position-relative">
                  <input
                    type="text"
                    value={row.departureTerm || ""}
                    placeholder={t("Departure")}
                    className="airport-code-input"
                    onChange={(e) =>
                      handleDepartureChange(index, e.target.value)
                    }
                  />
                  {row.departureLoading && (
                    <Spinner animation="border" size="sm" />
                  )}
                  {row.openDepartureList && row.departureItems?.length > 0 && (
                    <div className="hotellist-autocomplete shadow-lg rounded-3">
                      {row.departureItems.map((it, idx) => (
                        <button
                          key={`${it.abbreviation}-${idx}`}
                          type="button"
                          className="hotellist-autocomplete-item"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            pickDepartureRow(index, it);
                          }}
                        >
                          <span className="texts">
                            <span className="title">
                              {it.label} ({it.abbreviation})
                            </span>
                            <span className="subtitle">{it.sublabel}</span>
                          </span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div>
                <img src={iconTrip} alt="" className="icon-trip" />
              </div>

              {/* Destination */}
              <div className="city-to">
                <span className="city-name">{t("Destination")}</span>
                <div className="position-relative">
                  <input
                    type="text"
                    value={row.destinationTerm || ""}
                    placeholder={t("Destination")}
                    className="airport-code-input"
                    onChange={(e) =>
                      handleDestinationChange(index, e.target.value)
                    }
                  />
                  {row.destinationLoading && (
                    <Spinner animation="border" size="sm" />
                  )}
                  {row.openDestinationList &&
                    row.destinationItems?.length > 0 && (
                      <div className="hotellist-autocomplete shadow-lg rounded-3">
                        {row.destinationItems.map((it, idx) => (
                          <button
                            key={`${it.abbreviation}-${idx}`}
                            type="button"
                            className="hotellist-autocomplete-item"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              pickDestinationRow(index, it);
                            }}
                          >
                            <span className="texts">
                              <span className="title">
                                {it.label} ({it.abbreviation})
                              </span>
                              <span className="subtitle">{it.sublabel}</span>
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                </div>
              </div>

              {/* زر الحذف */}
              <button
                type="button"
                onClick={() => removeMultiCityRow(index)}
                style={{
                  position: "absolute",
                  top: "29px",
                  right: "-250px",
                  padding: "3px 15px",
                  borderRadius: "5px",
                  border: "none",
                  background: "#F3F3F3",
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#000",
                }}
              >
                ×
              </button>
            </div>
          </Col>

          {/* Leaving On */}
          <Col sm={4} md={2} lg={2} className="position-relative">
            <div
              className="trip-info-div search-box"
              onClick={() => {
                const newRows = [...multiCityRows];
                newRows[index].showCal = true;
                setMultiCityRows(newRows);
              }}
            >
              <div>
                <img src={dateIcon} alt="" className="date-icon" />
              </div>
              <div className="trip-info-text">
                <span className="info-text">{t("LeavingOn")}</span>
                <span className="info-date">
                  {row.leavingOn
                    ? new Date(row.leavingOn).toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : t("SelectDate")}
                </span>
              </div>
            </div>
            {row.showCal && (
              <div
                className="hotellist-calendar-popover shadow-lg rounded-3 p-2"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  zIndex: 1000,
                }}
              >
                <Calendar
                  value={row.leavingOn ? new Date(row.leavingOn) : null}
                  onChange={(e) => {
                    const newRows = [...multiCityRows];
                    // newRows[index].leavingOn = e.value
                    //   .toISOString()
                    //   .split("T")[0];
                      newRows[index].leavingOn = e.value.toLocaleDateString("en-CA");
                    newRows[index].showCal = false;
                    setMultiCityRows(newRows);
                  }}
                  selectionMode="single"
                  inline
                  readOnlyInput
                  minDate={today}
                  maxDate={maxBookDate}
                />
              </div>
            )}
          </Col>

          {/* Returning On */}
          {selectedOption === "RoundTrip" && (
            <Col sm={4} md={2} lg={2}>
              <div
                className="trip-info-div search-box"
                onClick={() => {
                  const newRows = [...multiCityRows];
                  newRows[index].showReturnCal = true;
                  setMultiCityRows(newRows);
                }}
              >
                <div>
                  <img src={dateIcon} alt="" className="date-icon" />
                </div>
                <div className="trip-info-text">
                  <span className="info-text">{t("ReturningOn")}</span>
                  <span className="info-date">
                    {row.returningOn
                      ? new Date(row.returningOn).toLocaleDateString("en-US", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : t("SelectDate")}
                  </span>
                </div>
              </div>
              {row.showReturnCal && (
                <div
                  className="hotellist-calendar-popover shadow-lg rounded-3 p-2"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    zIndex: 1000,
                  }}
                >
                  <Calendar
                    value={row.returningOn ? new Date(row.returningOn) : null}
                    onChange={(e) => {
                      const newRows = [...multiCityRows];
                      // newRows[index].returningOn = e.value
                      //   .toISOString()
                      //   .split("T")[0];
                        newRows[index].returningOn = e.value.toLocaleDateString("en-CA");
                      newRows[index].showReturnCal = false;
                      setMultiCityRows(newRows);
                    }}
                    selectionMode="single"
                    inline
                    readOnlyInput
                    minDate={today}
                    maxDate={maxBookDate}
                  />
                </div>
              )}
            </Col>
          )}
        </Row>
      ))}

      {/* زر إضافة رحلة */}
      {selectedOption === "MultiCity" && (
        <div className="mt-3">
          <Button variant="outline-primary" onClick={addMultiCityRow}>
            + {t("AddFlight")}
          </Button>
        </div>
      )}

      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
    </div>
  );
}
